import { Card, CardBody, Row, Col, Button, FormFeedback } from "reactstrap";
import { LabelText } from "../Utils/Input";
import SelectField from "../Utils/SelectField";
import { DocumentUploadOptions } from "./constants/constantValues";
import InputField from "../Utils/InputField";
import { documentTableColumns } from "./constants/CustomerTableColumns";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import {
  deleteDocument,
  emptyFieldsOfDocuments,
  getFile,
  handleChangeForDocumentName,
  handleChangeForDocumentType,
  payload,
  submitDocument,
  toggleModal,
  setFieldEmpty,
  verifyDocumentApiCall,
} from "./constants/HandleChangeFunctions";
import { customerIdData } from "./constants/constantFunctionsView";
import UploadDocumentTable from "./UploadDocumentTable";
import { ToastContainer, toast } from "react-toastify";
import { Loader } from "../Utils/Loader";
import { documentDataFunction } from "./constants/CustomerJsonObj";
import CommonModal from "../Utils/CommonModal";
import { deleteDoc } from "../../slices/customer/documentdelete/thunk";
import {
  clearDocFunction,
  displayVerifyModal,
  uploadSubmitFunction,
} from "./constants/DocumentTableFunctions";

export default function UploadDocument({
  fetchDocumentData,
  isEdit,
  open,
  setIsOpen,
  file,
  setFile,
  fileName,
  setFileName,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  setFieldTouched,
  setState,
}) {
  const [messageForPopUp, setMessageForPopUp] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [fields, setFields] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [editedDocumentName, setEditedDocumentName] = useState("");
  const [editedDocumentType, setEditedDocumentType] = useState(null);
  const [validationTriggered, setValidationTriggered] = useState(false);
  const [profileData, setProfileData] = useState();
  const roleName = localStorage.getItem("roleName");

  const customerId =
    roleName === "Customer"
      ? localStorage.getItem("customerId")
      : customerIdData();
  const [fileSizeValid, setFileSizeValid] = useState(true);
  const dispatch = useDispatch();
  let approvePayload = {};
  let rejectPayload = {};
  let documentsOfCustomer = [];
  let partnerOrCustomer = "";
  documentsOfCustomer = documentDataFunction(fetchDocumentData);

  const columns = documentTableColumns(
    documentsOfCustomer,
    open,
    setIsOpen,
    setButtonText,
    setMessageForPopUp,
    fields,
    setFields,
    handleChange,
    editingRow,
    editedDocumentName,
    setEditedDocumentName,
    editedDocumentType,
    setEditedDocumentType,
    customerId,
    approvePayload,
    rejectPayload,
    dispatch,
    setLoading
  );

  return (
    <div>
      {isEdit && (
        <div className="border rounded-1 p-3 mt-3">
          <h4 className="card-title mb-2 flex-grow-1 rv-form-title">
            Documents
          </h4>

          {/* <ToastContainer position="top-center" /> */}
          {loading && <Loader />}
          <>
            <Row className="gy-4">
              <Col xxl={3} md={6} className="pe-0">
                <LabelText
                  htmlFor={"documentType"}
                  classLabelName={"ms-0 rv-form-label"}
                  displayText={"Document Type"}
                />
                <SelectField
                  handleChange={handleChangeForDocumentType(
                    setFieldValue,
                    setFieldTouched,
                    setState
                  )}
                  className={
                    (errors.documentType && touched.documentType) || false
                      ? "error-input"
                      : ""
                  }
                  name={"documentType"}
                  value={values.documentType}
                  options={DocumentUploadOptions}
                  placeholder={" "}
                  isRVStyle={true}
                />
                {touched.documentType && errors.documentType ? (
                  <p className="text-danger">{errors.documentType}</p>
                ) : null}
              </Col>
              <Col xxl={3} md={6} className="pe-0">
                <LabelText
                  htmlFor={"documentName"}
                  classLabelName={"ms-0 rv-form-label"}
                  displayText={"Document Name"}
                />
                <InputField
                  name={"documentName"}
                  type={"text"}
                  className={"form-control"}
                  handleChange={handleChangeForDocumentName(
                    setState,
                    handleChange
                  )}
                  handleBlur={handleBlur}
                  value={values.documentName}
                  invalid={
                    touched.documentName && errors.documentName ? true : false
                  }
                />
                {touched.documentName && errors.documentName ? (
                  <FormFeedback type="invalid">
                    {errors.documentName}
                  </FormFeedback>
                ) : null}
              </Col>
              <Col className=" d-flex justify-content-between align-items-center gap-2">
                <div className="justify-content-start mx-0 px-0 w-100">
                  <LabelText
                    htmlFor={"selectedFile"}
                    classLabelName={"ms-0 rv-form-label"}
                    displayText={"Attachments"}
                  />
                  <InputField
                    name={"selectedFile"}
                    className={"form-control"}
                    handleBlur={handleBlur}
                    accept={".png, .jpg, .jpeg, .pdf"}
                    handleChange={getFile(
                      setFile,
                      setFileName,
                      handleChange,
                      setState,
                      setValidationTriggered,
                      setFileSizeValid
                    )}
                    value={values.selectedFile}
                    type={"file"}
                    invalid={validationTriggered}
                  />
                  {validationTriggered ? (
                    <FormFeedback type="invalid">
                      {file
                        ? "File size exceeds the limit (10MB)."
                        : "Kindly select a file"}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="d-flex justify-content-end align-items-center gap-2 ">
                  <Button
                    className={
                      "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap mt-4"
                    }
                    onClick={() =>
                      clearDocFunction(emptyFieldsOfDocuments, setFieldValue)
                    }
                  >
                    <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2 px-0 mx-0"></i>

                    <span className="px-0 ps-2 ms-2 me-1">Clear</span>
                  </Button>
                  <Button
                    className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap mt-4"
                    type="button"
                    disabled={!fileSizeValid}
                    onClick={() =>
                      uploadSubmitFunction(
                        values,
                        file,
                        customerId,
                        dispatch,
                        setLoading,
                        setFieldEmpty,
                        setFieldValue,
                        setState,
                        setFieldTouched
                      )
                    }
                  >
                    <i className="ri-upload-line label-icon align-middle fs-16 me-2"></i>
                    <span className="px-0 ps-2 ms-2 me-1">Submit</span>
                  </Button>
                </div>
              </Col>
            </Row>
            <div className="mt-3 border rounded-1">
              <UploadDocumentTable
                setProfileData={setProfileData}
                partnerOrCustomer={partnerOrCustomer}
                setLoading={setLoading}
                dispatch={dispatch}
                customerId={customerId}
                setIsOpen={setIsOpen}
                open={open}
                toggleModal={toggleModal}
                setFields={setFields}
                setEditingRow={setEditingRow}
                setEditedDocumentName={setEditedDocumentName}
                setEditedDocumentType={setEditedDocumentType}
                deleteDocument={deleteDocument}
                setButtonText={setButtonText}
                setMessageForPopUp={setMessageForPopUp}
                columns={columns}
                docTableMockData={documentsOfCustomer}
              />
            </div>
          </>
          {open ? (
            <CommonModal
              toggle={() => toggleModal(setIsOpen, open)}
              open={open}
              messageForPopUp={messageForPopUp}
              buttonText={buttonText}
              modalAction={() => {
                displayVerifyModal(
                  buttonText,
                  dispatch,
                  payload,
                  setLoading,
                  customerId,
                  setIsOpen,
                  open
                );
              }}
            />
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
}
